import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PresentExpoLayer from "../components/PresentExpoLayer";

const PresentExpoPage = () => {
    return (
        <MasterLayout>
            <PresentExpoLayer />
        </MasterLayout>
    );
};

export default PresentExpoPage;
